export default "__VITE_ASSET__sfJvC1MC__"